<template>
  <Transition>
    <div
      v-if="isShow"
      ref="iuOverlay"
      class="iu-widget__overlay"
      :class="{ 'iu-widget--in-drag': inDrag }"
      @click="isShow = false"
      @dragover.prevent.stop="inDrag = true"
      @dragleave.prevent.stop="inDrag = false"
      @drop.prevent.stop="uploadFromDrop"
    >
      <div class="iu-widget__wrapper">
        <div v-if="settings.custom_style" v-html="settings.custom_style" />
        <div
          ref="iuPopup"
          class="iu-widget__popup"
          :class="{ 'iu-widget__popup-congrats': currentStep == 'congrats' }"
          @click.stop
          @dragover.prevent.stop="inDrag = true"
        >
          <template v-if="currentStep !== 'congrats'">
            <div class="iu-widget__close" @click="isShow = false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.05044 7.04331C6.79009 7.30366 6.79009 7.72577 7.05044 7.98612L15.0641 15.9998L7.05021 24.0136C6.78986 24.274 6.78986 24.6961 7.05021 24.9565C7.31056 25.2168 7.73267 25.2168 7.99302 24.9565L16.0069 16.9426L24.021 24.9567C24.2813 25.217 24.7035 25.217 24.9638 24.9567C25.2242 24.6963 25.2242 24.2742 24.9638 24.0139L16.9497 15.9998L24.9636 7.98589C25.2239 7.72554 25.2239 7.30343 24.9636 7.04309C24.7032 6.78274 24.2811 6.78274 24.0208 7.04309L16.0069 15.057L7.99324 7.04331C7.73289 6.78297 7.31078 6.78297 7.05044 7.04331Z"
                />
              </svg>
            </div>
            <div class="iu-widget__modal-title">Написать отзыв о товаре</div>
            <div class="iu-widget__description">
              Перед публикацией обзора, пожалуйста, изучите Правила публикации.
              Мы тщательно проверяем прикрепленные материалы, чтобы покупателям
              поступала достоверная и качественная информация.
            </div>
            <div class="iu-widget__post-form">
              <label>Имя *</label>
              <input
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.username,
                }"
                v-model="username"
                type="text"
                @input="error = null"
                placeholder="Укажите ваше имя"
              />
              <span
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.username,
                }"
              >
                {{
                  !error || errorType !== errorTypes.username
                    ? "Отображается с обзором"
                    : error
                }}
              </span>
              <label>Email *</label>
              <input
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.email,
                }"
                v-model="email"
                type="text"
                @input="error = null"
                placeholder="Укажите ваш email"
              />
              <span
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.email,
                }"
              >
                {{
                  !error || errorType !== errorTypes.email
                    ? "Никогда не отображается публично"
                    : error
                }}
              </span>
              <label>Ваши впечатления о товарах</label>
              <textarea
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.description,
                }"
                v-model="caption"
                type="text"
                rows="3"
                placeholder="Опишите достоинства товара"
                maxlength="1000"
              />
              <span
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.description,
                }"
              >
                {{
                  !error || errorType !== errorTypes.description
                    ? "Максимальное количество символов: 1000"
                    : error
                }}
              </span>
              <label>Другие товары в обзоре</label>
              <template v-for="index in countOfProducts" :key="index">
                <input
                  @input="(e) => replaceProduct(e, index)"
                  type="text"
                  placeholder="Названия товара, артикул или ссылка"
                  class="iu-widget__post-form-additional-product"
                />
              </template>
              <div
                v-if="this.countOfProducts < 10"
                class="iu-widget__title iu-widget__title--medium iu-widget__title--add-photo"
                @click="addProduct"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2.5C11.7239 2.5 11.5 2.72386 11.5 3V11.5H3C2.72386 11.5 2.5 11.7239 2.5 12C2.5 12.2761 2.72386 12.5 3 12.5H11.5V21C11.5 21.2761 11.7239 21.5 12 21.5C12.2761 21.5 12.5 21.2761 12.5 21V12.5H21C21.2761 12.5 21.5 12.2761 21.5 12C21.5 11.7239 21.2761 11.5 21 11.5H12.5V3C12.5 2.72386 12.2761 2.5 12 2.5Z"
                    fill="#141313"
                  />
                </svg>
                Добавить товар
              </div>
            </div>
            <div
              v-if="!limitIsFull && !uploadProcess"
              class="iu-widget-upload iu-widget-upload--short"
            >
              <div class="iu-widget-upload__hint">
                <span class="file-uploader__title">
                  Нажмите на кнопку или перетащите файлы в эту область
                </span>
                <span class="file-uploader__descr">
                  до 5 файлов в формате JPG, JPEG, PNG, BMP, GIF, MOV
                </span>
                <span class="file-uploader__descr">
                  Видео длительностью не более 3 минут
                </span>
              </div>
              <button
                class="file-upload-button"
                type="button"
                data-type="file-input"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11.1364 17.3333H20.3896C21.0029 17.3333 21.5 16.8362 21.5 16.2229V7.33261C21.5 6.71936 21.0029 6.22222 20.3896 6.22222C19.4774 6.22222 18.5651 6.22222 17.6529 6.22222C17.2815 6.22222 16.9347 6.03656 16.7288 5.72749L15.9075 4.49473C15.7016 4.18566 15.3548 4 14.9834 4H11.7308C11.3595 4 11.0127 4.18567 10.8068 4.49473L9.98545 5.72749C9.77954 6.03656 9.43275 6.22222 9.06137 6.22222H6.32468C5.71142 6.22222 5.21429 6.71936 5.21429 7.33261V11.4074M5.21429 14.6667V20M7.92857 17.3333H2.5M16.3182 11.4074C16.3182 13.0438 14.9925 14.3704 13.3571 14.3704C11.7218 14.3704 10.3961 13.0438 10.3961 11.4074C10.3961 9.77101 11.7218 8.44444 13.3571 8.44444C14.9925 8.44444 16.3182 9.77101 16.3182 11.4074Z"
                    stroke="#141313"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Загрузить файл</span>
              </button>
              <input
                title="Загрузи файлы"
                type="file"
                multiple
                accept="image/x-png, image/png, image/jpeg, video/*"
                @change="uploadFromInput"
              />
            </div>
            <div
              v-if="uploadProcess || uploadedFiles.length"
              class="iu-widget-preview"
            >
              <div v-if="uploadProcess" class="iu-widget-upload__progress">
                <div class="iu-widget-upload__loader">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.3334 1.66699C19.4493 1.66699 18.6015 2.01818 17.9764 2.6433C17.3512 3.26842 17 4.11627 17 5.00032C17 5.88438 17.3512 6.73223 17.9764 7.35735C18.6015 7.98247 19.4493 8.33366 20.3334 8.33366C21.2174 8.33366 22.0653 7.98247 22.6904 7.35735C23.3155 6.73223 23.6667 5.88438 23.6667 5.00032C23.6667 4.11627 23.3155 3.26842 22.6904 2.6433C22.0653 2.01818 21.2174 1.66699 20.3334 1.66699ZM20.3334 32.5003C19.6703 32.5003 19.0345 32.7637 18.5656 33.2326C18.0968 33.7014 17.8334 34.3373 17.8334 35.0003C17.8334 35.6634 18.0968 36.2992 18.5656 36.7681C19.0345 37.2369 19.6703 37.5003 20.3334 37.5003C20.9964 37.5003 21.6323 37.2369 22.1011 36.7681C22.57 36.2992 22.8334 35.6634 22.8334 35.0003C22.8334 34.3373 22.57 33.7014 22.1011 33.2326C21.6323 32.7637 20.9964 32.5003 20.3334 32.5003ZM35.5 18.8337C35.058 18.8337 34.6341 19.0093 34.3215 19.3218C34.009 19.6344 33.8334 20.0583 33.8334 20.5003C33.8334 20.9424 34.009 21.3663 34.3215 21.6788C34.6341 21.9914 35.058 22.167 35.5 22.167C35.9421 22.167 36.366 21.9914 36.6786 21.6788C36.9911 21.3663 37.1667 20.9424 37.1667 20.5003C37.1667 20.0583 36.9911 19.6344 36.6786 19.3218C36.366 19.0093 35.9421 18.8337 35.5 18.8337ZM5.33337 17.0003C4.93941 17.0003 4.5493 17.0779 4.18532 17.2287C3.82135 17.3794 3.49063 17.6004 3.21205 17.879C2.93348 18.1576 2.7125 18.4883 2.56174 18.8523C2.41097 19.2162 2.33337 19.6064 2.33337 20.0003C2.33337 20.3943 2.41097 20.7844 2.56174 21.1484C2.7125 21.5124 2.93348 21.8431 3.21205 22.1216C3.49063 22.4002 3.82135 22.6212 4.18532 22.772C4.5493 22.9227 4.93941 23.0003 5.33337 23.0003C5.72734 23.0003 6.11745 22.9227 6.48143 22.772C6.8454 22.6212 7.17612 22.4002 7.4547 22.1216C7.73327 21.8431 7.95425 21.5124 8.10501 21.1484C8.25578 20.7844 8.33337 20.3943 8.33337 20.0003C8.33337 19.6064 8.25578 19.2162 8.10501 18.8523C7.95425 18.4883 7.73327 18.1576 7.4547 17.879C7.17612 17.6004 6.8454 17.3794 6.48143 17.2287C6.11745 17.0779 5.72734 17.0003 5.33337 17.0003ZM31 5.16699C29.895 5.16699 28.8352 5.60598 28.0538 6.38738C27.2724 7.16878 26.8334 8.22859 26.8334 9.33366C26.8334 10.4387 27.2724 11.4985 28.0538 12.2799C28.8352 13.0613 29.895 13.5003 31 13.5003C32.1051 13.5003 33.1649 13.0613 33.9463 12.2799C34.7277 11.4985 35.1667 10.4387 35.1667 9.33366C35.1667 8.22859 34.7277 7.16878 33.9463 6.38738C33.1649 5.60598 32.1051 5.16699 31 5.16699ZM9.66671 27.667C8.87106 27.667 8.108 27.9831 7.54539 28.5457C6.98278 29.1083 6.66671 29.8713 6.66671 30.667C6.66671 31.4626 6.98278 32.2257 7.54539 32.7883C8.108 33.3509 8.87106 33.667 9.66671 33.667C10.4624 33.667 11.2254 33.3509 11.788 32.7883C12.3506 32.2257 12.6667 31.4626 12.6667 30.667C12.6667 29.8713 12.3506 29.1083 11.788 28.5457C11.2254 27.9831 10.4624 27.667 9.66671 27.667ZM31 28.667C30.7374 28.667 30.4773 28.7187 30.2347 28.8192C29.992 28.9197 29.7715 29.0671 29.5858 29.2528C29.4001 29.4385 29.2528 29.659 29.1523 29.9016C29.0518 30.1443 29 30.4043 29 30.667C29 30.9296 29.0518 31.1897 29.1523 31.4324C29.2528 31.675 29.4001 31.8955 29.5858 32.0812C29.7715 32.2669 29.992 32.4142 30.2347 32.5147C30.4773 32.6153 30.7374 32.667 31 32.667C31.2627 32.667 31.5228 32.6153 31.7654 32.5147C32.0081 32.4142 32.2285 32.2669 32.4143 32.0812C32.6 31.8955 32.7473 31.675 32.8478 31.4324C32.9483 31.1897 33 30.9296 33 30.667C33 30.4043 32.9483 30.1443 32.8478 29.9016C32.7473 29.659 32.6 29.4385 32.4143 29.2528C32.2285 29.0671 32.0081 28.9197 31.7654 28.8192C31.5228 28.7187 31.2627 28.667 31 28.667ZM9.66671 6.33366C9.27274 6.33366 8.88263 6.41126 8.51866 6.56202C8.15468 6.71278 7.82396 6.93376 7.54539 7.21234C7.26681 7.49091 7.04583 7.82163 6.89507 8.18561C6.74431 8.54958 6.66671 8.93969 6.66671 9.33366C6.66671 9.72762 6.74431 10.1177 6.89507 10.4817C7.04583 10.8457 7.26681 11.1764 7.54539 11.455C7.82396 11.7336 8.15468 11.9545 8.51866 12.1053C8.88263 12.2561 9.27274 12.3337 9.66671 12.3337C10.0607 12.3337 10.4508 12.2561 10.8148 12.1053C11.1787 11.9545 11.5095 11.7336 11.788 11.455C12.0666 11.1764 12.2876 10.8457 12.4383 10.4817C12.5891 10.1177 12.6667 9.72762 12.6667 9.33366C12.6667 8.93969 12.5891 8.54958 12.4383 8.18561C12.2876 7.82163 12.0666 7.49091 11.788 7.21234C11.5095 6.93376 11.1787 6.71278 10.8148 6.56202C10.4508 6.41126 10.0607 6.33366 9.66671 6.33366Z"
                      fill="#000"
                    />
                  </svg>
                </div>
                Обработано {{ filesProcessed }} из
                {{ filesToUpload.length }} файлов.&nbsp;
                <span v-if="isVideoCompression"> Сжатие медиа </span>
                <span v-else> Загрузка медиа </span>
              </div>
              <div class="iu-widget__media-list">
                <div
                  v-for="(media, index) in uploadedFiles"
                  :key="media.id"
                  class="iu-widget__media-item"
                >
                  <img
                    ref="uploadedImages"
                    :src="media.url"
                    class="iu-widget-item-image"
                    @error="reloadImage(index, media.url)"
                  />
                  <div
                    class="iu-widget-item-close"
                    @click="uploadedFiles.splice(index, 1)"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1C8.33333 8.33333 23 23 23 23"
                        stroke="#7C0000"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                      <path
                        d="M23 1C15.6667 8.33333 1 23 1 23"
                        stroke="#7C0000"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!uploadProcess && error && !errorType"
              class="iu-widget-message iu-widget-upload__error"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11ZM12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16ZM12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6L10 13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13L12 6Z"
                  fill="#2C2C2C"
                />
              </svg>
              <span>{{ error }}</span>
            </div>
            <label class="iu-widget-checkbox" @click="error = null">
              <input
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.agreement,
                }"
                v-model="agreedWithRules"
                type="checkbox"
                :checked="agreedWithRules"
              />
              <div
                :class="{
                  'iu-widget__post-form--error':
                    error && errorType == errorTypes.agreement,
                }"
                class="iu-widget-checkbox__toggle"
              >
                Даю согласие на обработку персональных данных
              </div>
            </label>
            <div class="iu-widget__controls">
              <div
                class="iu-widget__next-button"
                :class="{
                  'iu-widget__next-button--disabled':
                    uploadProcess || !uploadedFiles.length || !agreedWithRules,
                }"
                @click="saveAsPost"
              >
                Отправить
              </div>
            </div>
          </template>
          <template v-else>
            <div class="iu-widget-message iu-widget-message-congrats">
              <div class="iu-widget__close" @click="isShow = false">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.05044 7.04331C6.79009 7.30366 6.79009 7.72577 7.05044 7.98612L15.0641 15.9998L7.05021 24.0136C6.78986 24.274 6.78986 24.6961 7.05021 24.9565C7.31056 25.2168 7.73267 25.2168 7.99302 24.9565L16.0069 16.9426L24.021 24.9567C24.2813 25.217 24.7035 25.217 24.9638 24.9567C25.2242 24.6963 25.2242 24.2742 24.9638 24.0139L16.9497 15.9998L24.9636 7.98589C25.2239 7.72554 25.2239 7.30343 24.9636 7.04309C24.7032 6.78274 24.2811 6.78274 24.0208 7.04309L16.0069 15.057L7.99324 7.04331C7.73289 6.78297 7.31078 6.78297 7.05044 7.04331Z"
                  />
                </svg>
              </div>
              <span class="iu-widget-message-congrats__title">
                Спасибо за ваше мнение!
              </span>
              <span class="iu-widget-message-congrats__description">
                Обзор отправлен на проверку, после которой он будет опубликован
                на сайте
              </span>
            </div>
          </template>
          <div
            v-if="inDrag"
            class="iu-widget-drop-area"
            :class="{
              'iu-widget-drop-area--limited': limitIsFull || uploadProcess,
            }"
          >
            <svg
              width="134"
              height="134"
              viewBox="0 0 134 134"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M67 122.834C97.8359 122.834 122.833 97.8362 122.833 67.0003C122.833 36.1644 97.8359 11.167 67 11.167C36.1641 11.167 11.1667 36.1644 11.1667 67.0003C11.1667 97.8362 36.1641 122.834 67 122.834Z"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M67 39.083L67 94.9163"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M39.0833 67L94.9166 67"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
// Modulse
import axios from "axios";
// Mixins
import analytics from "../../common/mixins/analytics";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { redirectToAuthPage } from "../services";

const bodyScrollLock = require("body-scroll-lock");

const errorTypes = {
  username: "USERNAME",
  email: "EMAIL",
  description: "DESCRIPTION",
  agreement: "AGREEMENT",
};

export default {
  mixins: [analytics],

  props: ["propSettings"],
  data() {
    const { logged_in_email, logged_in_id } = this.propSettings;

    return {
      settings: this.propSettings || {},
      maxLimit: 5,
      isShow: true,
      currentStep: "upload",
      filesToUpload: null,
      filesProcessed: 0,
      uploadedFiles: [],
      uploadProcess: false,
      error: null,
      errorType: "",
      username: logged_in_id || "",
      email: logged_in_email || "",
      additionalProducts: [],
      countOfProducts: 1,
      caption: "",
      agreedWithRules: false,
      inDrag: false,
      labelItemPosition: ["url", "friPostId", "uploadPhotoCount"],
      categoryPostfix: "IUpload",
      isVideoCompression: false,
    };
  },

  created() {
    this.errorTypes = errorTypes;
  },

  mounted() {
    document.addEventListener("frisbuy:iu-open", this.showPopup);
  },
  beforeUnmount() {
    document.removeEventListener("frisbuy:iu-open", this.showPopup);
  },
  computed: {
    limitIsFull() {
      const { uploadedFiles, maxLimit } = this;

      return uploadedFiles.length >= maxLimit;
    },

    trackingSkuId() {
      const { skuId, groupId, categoryId } = this.settings;

      return (
        (skuId && `_sku${skuId}`) ||
        (groupId && `_skug${groupId}`) ||
        (categoryId && `_cat${categoryId}`) ||
        ""
      );
    },

    isUserLoggedIn() {
      const { logged_in_id, logged_in_email, logged_in_phone } = this.settings;

      return !!logged_in_id && !!logged_in_email && !!logged_in_phone;
    },
  },

  watch: {
    currentStep(newStepName, oldStepName) {
      if (newStepName === "post") {
        this.sendAnalyticEvent("UplphotoUploaded", {
          link: location.href,
          linklabel: document.title,
        });
      }

      if (oldStepName === "upload") return;

      this.error = null;
    },

    isShow: {
      handler(value) {
        const { logged_in_email, logged_in_id } = this.settings;

        if (value) {
          this.sendAnalyticEvent("UplphotoOpen");

          if (this.settings.auth_page_url && !this.isUserLoggedIn) {
            const backUrl = window.location.href;
            redirectToAuthPage(this.settings.auth_page_url, backUrl);

            this.closePopup();
            return;
          }

          this.$nextTick(() => {
            const { $el, $refs } = this;
            const isMobile = Math.min(window.innerWidth, screen.width) < 569;

            document.body.appendChild($el);
            bodyScrollLock.disableBodyScroll(
              isMobile ? $refs.iuOverlay : $refs.iuPopup
            );
          });

          return;
        }
        bodyScrollLock.clearAllBodyScrollLocks();

        this.currentStep = "upload";
        this.filesToUpload = null;
        this.filesProcessed = 0;
        this.uploadedFiles = [];
        this.uploadProcess = false;
        this.error = null;
        this.caption = "";
        this.username = logged_in_id || "";
        this.email = logged_in_email || "";
        this.agreedWithRules = false;
      },

      immediate: true,
    },
  },

  methods: {
    replaceProduct(e, index) {
      this.additionalProducts[index - 1] = e.target.value;
    },

    addProduct() {
      if (this.countOfProducts >= 10) return;

      this.countOfProducts += 1;
    },

    showPopup() {
      this.isShow = true;
    },

    closePopup() {
      this.isShow = false;
    },

    componentAction({ action }) {
      const { settings, trackingSkuId } = this;

      return `${action}_embedID${settings.embedId + trackingSkuId}`;
    },

    uploadFromDrop(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.dataTransfer;

      this.inDrag = false;

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFromInput(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.target;

      this.errorType = "";

      if (limitIsFull || uploadProcess) return;

      this.filesToUpload = [...files].slice(0, maxLimit - uploadedFiles.length);

      uploadFiles();
    },

    uploadFiles() {
      const { filesToUpload, settings } = this;
      const { srcDomain, embedId } = settings;

      this.uploadProcess = true;
      this.filesProcessed = 0;
      this.error = null;

      filesToUpload.forEach((file) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        if (file.size > 50 * 1024 * 1024) {
          this.filesProcessed += 1;
          this.error = `${this.error || ""}Файл превышает размер 50 мегабайт`;

          if (this.filesProcessed !== filesToUpload.length) return;

          this.uploadProcess = false;
          this.filesToUpload = [];
          this.currentStep = "preview";

          return;
        }

        axios({
          url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/medias?embed_id=${embedId}`),
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progress) => {
            const isUploaded = progress.total === progress.loaded;

            if (isUploaded) {
              this.isVideoCompression = true;
            }
          },
        })
          .then(({ data }) => {
            const { request, response } = data;
            const { success, statusMessage } = request;
            const { post_media } = response.body;

            if (!success) {
              this.error = statusMessage;
              return;
            }

            this.uploadedFiles.push(post_media);
          })
          .catch((error) => {
            const { response } = error;

            this.sendAnalyticEvent("UplphotoError", {
              link: location.href,
              linklabel: document.title,
              error: this.error,
            });

            if (!response || typeof response.data.request === "string") {
              if (error && response && response.status === 413) {
                this.error =
                  (this.error || "") +
                  `Файл '${file.name}' превышает размер 50 мегабайт` +
                  "\n";
                return;
              }

              this.error = "Ошибка на сервере, попробуйте позже";
              return;
            }

            if (this.error === null) {
              this.error = `${response.data.request.error}\n`;
            } else {
              this.error += `${response.data.request.error}\n`;
            }
          })
          .finally(() => {
            this.filesProcessed += 1;

            if (this.filesProcessed !== filesToUpload.length) return;

            this.uploadProcess = false;
            this.isVideoCompression = false;
            this.filesToUpload = [];
            this.currentStep = "preview";
          });
      });
    },

    saveAsPost() {
      let {
        uploadedFiles,
        username,
        email,
        agreedWithRules,
        settings,
        caption,
      } = this;
      const { srcDomain, embedId, logged_in_id } = settings;
      const emailReg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      email = email.trim();
      this.error = null;
      this.errorType = "";

      if (!username) {
        this.error = "Обязательное поле";
        this.errorType = this.errorTypes.username;
        return;
      }
      if (!email || !emailReg.test(email)) {
        this.error = "Пожалуйста, введите правильный E-mail адрес";
        this.errorType = this.errorTypes.email;
        return;
      }
      if (!agreedWithRules) {
        this.error =
          "Пожалуйста, подтвердите ознакомление с правилами пользования сайтом";
        this.errorType = this.errorTypes.agreement;
        return;
      }

      if (caption.length > 1000) {
        this.error = "Максимальное количество символов: 1000";
        this.errorType = this.errorTypes.description;
        return;
      }

      const additionalCaption = caption + this.additionalProducts.join("\n");

      axios({
        url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/posts?embed_id=${embedId}`),
        method: "POST",
        data: {
          post_medias: uploadedFiles,
          email,
          username,
          logged_in_id,
          caption: additionalCaption,
          url: encodeURIComponent(location.href),
        },
      })
        .then(({ data }) => {
          const { success, statusMessage } = data.request;

          if (!success) {
            this.error = statusMessage;
            return;
          }

          this.sendAnalyticEvent("UplphotoOK", {
            url: location.href,
            uploadPhotoCount: uploadedFiles.length,
            link: location.href,
            linklabel: document.title,
          });

          this.currentStep = "congrats";

          setTimeout(() => {
            this.isShow = false;
          }, 3000);
        })
        .catch((error) => {
          const { response } = error;

          this.sendAnalyticEvent("UplphotoError", {
            link: location.href,
            linklabel: document.title,
            error: this.error,
          });

          if (response) {
            const { data } = response;

            this.error = data.request.error;
          } else {
            this.error = "Ошибка на сервере, попробуйте позже";
          }
        });
    },

    reloadImage(index, url) {
      /*
        NOTE: Backend cache return 404 error.
        To update cache I use random query param
      */
      const randomValue = Math.random().toString().slice(2);
      const randomQueryParam = `random_query_param=${randomValue}`;

      const fixedUrl = `${url}?recovery=true&${randomQueryParam}`;
      this.$refs.uploadedImages[index].src = fixedUrl;
    },
  },
};
</script>

<style lang="scss">
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-5%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  transform: translateY(-5%);
  opacity: 0;
}

.iu-widget__overlay {
  font-family: "Stolzl", sans-serif;
  background-color: rgba(77, 77, 77, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100vw;
  min-height: 100vh;
  z-index: 99999999999999;
  animation: iu-show 0.3s linear;
  color: #2c2c2c;
  overflow: auto;

  * {
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    &::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-thumb {
      background: #a4a4a4;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-thumb:hover,
    &::-webkit-scrollbar-thumb:active {
      background: #a4a4a4;
    }

    &::-webkit-scrollbar-track {
      background: #ffffff;
      border: 0px none #ffffff;
      border-radius: 50px;
    }

    &::-webkit-scrollbar-track:hover,
    &::-webkit-scrollbar-track:active {
      background: #ffffff;
    }

    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
    border-bottom: 1px solid #c0c0c0;
  }

  &.iu-widget--in-drag {
    .iu-widget__popup {
      pointer-events: none;
    }
  }
}

.iu-widget__wrapper {
  padding: 20px 56px;
  margin: 0 auto;

  animation: slideDown 0.2s linear;

  @media (min-width: 568px) {
    max-width: calc(610px + 56px * 2);
  }

  @media (max-width: 575px) {
    align-items: unset;
    margin: 0;
    padding: 0;
  }
}

.iu-widget__popup {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  background: #ffffff;
  padding: 56px;
  position: relative;
  border-radius: 0.5rem;
  margin: 0 auto;

  @media (max-width: 1199px) {
    padding: 16px;
  }

  @media (max-width: 991px) {
    gap: 24px;
  }
}

.iu-widget-drop-area {
  position: absolute;
  background-color: rgba(30, 129, 189, 0.15);
  backdrop-filter: blur(5px);
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.iu-widget-drop-area--limited {
    background-color: rgba(189, 30, 30, 0.15);
    svg {
      transform: rotate(45deg);
    }
  }
}

.iu-widget__close {
  position: absolute;
  top: 0px;
  right: -4px;
  transform: translateX(100%);
  width: 24px;
  height: 24px;
  cursor: pointer;

  svg {
    fill: #fff;
    max-width: 32px;
    max-height: 32px;
  }

  @media (max-width: 1199px) {
    transform: none;
    top: 24px;
    right: 16px;

    svg {
      fill: #aeaeae;
      max-width: 24px;
      max-height: 24px;
    }
  }
}

.iu-widget__description {
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: #404040;

  @media (max-width: 1199px) {
    font-size: 14px;
    line-height: 21px;
  }
}

.iu-widget__modal-title {
  font-size: 28px;
  line-height: 1.3;
  color: #000;

  @media (max-width: 1199px) {
    font-size: 20px;
    margin-top: 8px;
  }
}

.iu-widget__title {
  font-size: 28px;
  line-height: 33px;

  &.iu-widget__title--medium {
    font-weight: 300;
    font-size: 14px;
    line-height: 21px;
  }

  &.iu-widget__title--add-photo {
    font-size: 16px;
    line-height: 24px;
    display: inline-flex;
    align-items: center;
    text-transform: none;
    cursor: pointer;

    @media (max-width: 1199px) {
      font-size: 14px;
      line-height: 21px;
    }

    svg {
      margin-right: 4px;
    }
  }
}

.iu-widget-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px;
  position: relative;
  background-color: #f2f3f3;

  + .iu-widget-upload__error {
    margin-top: 0;

    span {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  input {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
  }
}

.iu-widget-upload--short {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  align-items: flex-start;
  position: relative;

  svg {
    width: 24px;
    height: 24px;
    position: absolute;
    top: calc(50% - 12px);
    left: 38px;
  }

  .iu-widget-upload__text {
    text-align: left;
    margin-top: 0;
  }

  .iu-widget-upload__hint {
    text-align: left;
    text-transform: none;
  }
}

.iu-widget-upload__text {
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  margin-top: 16px;

  .iu-widget-upload__text--mobile {
    display: none;
  }
}

.iu-widget-upload__hint {
  font-size: 12px;
  line-height: 16px;
  color: #5e5e5e;
  text-align: center;

  .iu-widget-upload__hint--mobile {
    display: none;
  }
}

.iu-widget-preview {
  margin: 5px 0 0;
}

.iu-widget-upload__loader {
  svg {
    margin-right: 20px;
    animation: spin 1s infinite linear;
  }
}

.iu-widget-upload__progress {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 18px 6px;
  color: #959595;
  font-size: 13px;
  line-height: 22px;
}

.iu-widget__media-list {
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
}

.iu-widget__media-item {
  width: 65px;
  height: 79px;
  border-radius: 10px;
  margin: 8px;
  background-color: #eaeaea;
  background-size: cover;
  position: relative;

  .iu-widget-item-close {
    position: absolute;
    background: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 100%;
    left: calc(50% - 13px);
    bottom: -13px;
    cursor: pointer;

    svg {
      max-width: 12px;
      max-height: 12px;
    }
  }

  .iu-widget-item-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
}

.iu-widget__controls {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .iu-widget__next-button {
    padding: 14px 31px;
    background: #141313;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    display: inline-block;
    text-align: center;
    text-transform: none;
    cursor: pointer;

    &:hover,
    &.iu-widget__next-button--disabled {
      color: #fff;
      background: #404040;
      border-color: #404040;
    }

    @media (max-width: 1199px) {
      font-size: 14px;
      line-height: 21px;
    }

    @media (max-width: 575px) {
      width: 100%;
    }
  }
}

.iu-widget__post-form {
  display: flex;
  flex-direction: column;

  label {
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;

    text-transform: uppercase;
    margin-bottom: 4px;

    @media (max-width: 568px) {
      font-size: 14px;
      line-height: 21px;
    }
  }

  input[type="text"],
  textarea {
    display: block;
    font-size: 1rem;
    font-family: Stolzl;

    color: #141313;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d4d4d4;
    border-radius: 2px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    appearance: none;
    outline: none;

    padding: 16px;
    height: 48px;
    font-weight: 300;
    box-shadow: none !important;

    &::placeholder {
      font-family: Stolzl;
      font-size: 16px;
      line-height: 24px;

      color: #7a7a7a;
    }

    &:hover,
    &:focus,
    &:focus-visible {
      border-color: #d0e548;
    }

    @media (max-width: 1199px) {
      font-size: 14px;
    }
  }

  span {
    margin-top: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 300;
    color: #7a7a7a;

    &:not(&:last-child) {
      margin-bottom: 32px;
    }

    @media (max-width: 991px) {
      &:not(&:last-child) {
        margin-bottom: 16px;
      }
    }
  }

  textarea {
    min-height: 122px;
    height: unset;
    resize: none;

    &::placeholder {
      opacity: 0.8;
    }
  }
}

.file-upload-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.15s ease;
  color: #141313;
  font-size: 14px;
  line-height: 1.5;
  user-select: none;
  border: 1px solid #141313;
  background-color: transparent;
  border-radius: 2px;
  padding: 12px 15px;

  @media (max-width: 1199px) {
    font-size: 12px;
    padding: 12px 23px;
    line-height: 18px;
  }

  &:hover {
    color: #141313;
    background-color: #f2f3f3;
    border-color: #141313;
  }

  span {
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    pointer-events: none;
    font-family: Stolzl, Arial, "Helvetica Neue", Helvetica, sans-serif;

    @media (max-width: 1199px) {
      font-size: 12px;
    }
  }

  svg {
    position: relative;
    max-width: 16px;
    max-height: 16px;
    margin-right: 8px;
    top: unset;
    left: unset;
  }
}

.iu-widget-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  border-color: #aeaeae;
  input[type="checkbox"] {
    position: absolute;

    margin: 0;
    margin-left: 0;
    width: 20px;
    height: 20px;
    pointer-events: none;

    background-color: #d0e548;
    border-radius: 2px;

    background-image: var(--bs-form-check-bg-image);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid #aeaeae;

    &:checked {
      box-shadow: inset 0 0 0 2px #ffffff;
      appearance: none;

      --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
    }
  }
}

.iu-widget-checkbox__toggle {
  min-width: 16px;
  min-height: 16px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  padding-left: calc(6px + 20px);
  opacity: 1;
  border-radius: 2px;
  line-height: 1.5;
  cursor: pointer;

  @media (max-width: 1199px) {
    font-size: 14px;
    line-height: 21px;
    font-weight: 300;
  }
}

.iu-widget-checkbox__label {
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
}

.iu-widget-message {
  background-color: #f4f4f4;
  padding: 18px 26px;
  display: flex;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;

  svg {
    margin-right: 14px;
    flex-shrink: 0;
  }
}

.iu-widget-upload__error {
  margin-top: 24px;

  background-color: #fcd8d9;

  & + .iu-widget-preview {
    margin-top: 0;
  }
}

@media (max-width: 768px) {
  .iu-widget-upload__text {
    .iu-widget-upload__text--desktop {
      display: none;
    }

    .iu-widget-upload__text--mobile {
      display: inherit;
    }
  }

  .iu-widget-upload__hint {
    .iu-widget-upload__hint--desktop {
      display: none;
    }

    .iu-widget-upload__hint--mobile {
      display: inherit;
    }
  }
}

@media (max-width: 575px) {
  .iu-widget__overlay {
    overflow-y: auto;
    overflow-x: hidden;
    align-items: flex-start;
    min-width: auto;
    min-height: auto;
  }

  .iu-widget__popup {
    width: 100%;
    min-height: 100%;
    max-height: auto;
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-radius: 0;
  }

  .iu-widget__close {
    width: 16px;
    height: 16px;
  }
  .iu-widget-upload {
    // flex-grow: 1;
    justify-content: center;
  }

  .iu-widget-upload__progress {
    flex-direction: column;
    margin-bottom: 8px;

    svg {
      margin: 0 0 18px 0;
    }
  }

  .iu-widget-preview {
    flex-grow: 1;
  }

  .iu-widget__media-item {
    width: 45px;
    height: 59px;
    margin: 6px;
  }
}

.file-uploader__title {
  font-size: 14px;
  line-height: 21px;
  font-weight: 300;
  display: inline-block;
  color: #000;

  @media (max-width: 991px) {
    font-size: 12px;
  }
}

.file-uploader__descr {
  display: inline-block;
  font-size: 14px;
  line-height: 21px;
  font-weight: 300;
  margin-top: 8px;
  color: #7a7a7a;
  @media (max-width: 991px) {
    font-size: 12px;
  }
}

.iu-widget__post-form--error {
  border-color: #f04f4f !important;
  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
  background-color: unset !important;
}

div.iu-widget__post-form--error,
span.iu-widget__post-form--error {
  color: #f04f4f !important;
}

.iu-widget__post-form-additional-product {
  &:not(&:last-child) {
    margin-bottom: 16px;
  }
}

.iu-widget__popup-congrats {
  border-radius: 0;
  padding: 56px;

  @media (max-width: 1199px) {
    .iu-widget__close {
      top: 26px;
      width: 24px;
      height: 24px;
    }
  }

  @media (max-width: 575px) {
    min-height: 100vh;
  }
}

.iu-widget-message-congrats {
  background-color: unset;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.iu-widget-message-congrats__description {
  font-size: 16px;
  line-height: 24px;
  margin-top: 32px;
}

.iu-widget-message-congrats__title {
  font-size: 28px;
  line-height: 36px;
}
</style>
